import { render, staticRenderFns } from "./CustomerCareLinks.vue?vue&type=template&id=a06855b2"
import script from "./CustomerCareLinks.vue?vue&type=script&lang=js"
export * from "./CustomerCareLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports